import React from "react";
import ReactPlayer from "react-player";
import { useLocation } from "react-router-dom";

const VideoPlayer = () => {
  const state = useLocation();
  const params = state.state;
  const url = params?.url;
  const isBunnyEmbed =
    typeof url === "string" && url.includes("iframe.mediadelivery.net/embed/");

  return (
    <div>
      {isBunnyEmbed ? (
        <iframe
          title="Video Player"
          src={url}
          style={{ width: "100%", height: "80vh", border: 0 }}
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
          allowFullScreen
        />
      ) : (
        <ReactPlayer url={url} controls={true} width="100%" height="100%" />
      )}
    </div>
  );
};

export default VideoPlayer;
